import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportMoBranch } from '@api/configurationComparison';

import { IManagedObjects } from '@interfaces/cmModule/cmModule';
import { TMoBranchDTO } from '@interfaces/cmModule/dto/cmModuleDTO';

import { ESnackbarTypes } from '@enums/common';

import { MO_BRANCH_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

type TExportMoBranch = Pick<TMoBranchDTO, 'comparisonId' | 'siteId' | 'gnbId' | 'delta' | 'paramName'> & {
	managedObjects: IManagedObjects[];
}

export const useMutateExportMoBranch = ({
	comparisonId,
	delta,
	siteId,
	gnbId,
	paramName,
	managedObjects,
}: TExportMoBranch) => {
	const dispatch = useAppDispatch();

	const { mutate: exportBranch } = useMutation({
		mutationKey: [
			MO_BRANCH_EXPORT,
			delta,
			siteId,
			gnbId,
			paramName,
			managedObjects,
		],
		mutationFn: () => {
			exportMoBranch({
				comparisonId,
				ids: [],
				isAll: true,
				filter: null,
			});
		},
		enabled: [!!comparisonId],
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportConfigurationComparisonSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return { exportBranch };
};
